import Component from '../colorz/Component';
import device   from '../colorz/utils/device';
import Flickity from 'flickity-imagesloaded';

/*
* Slider Knowledge Enfant Direct
* voir template strate-knowledge_slider.php
*/

module.exports = class KnowledgeClassicSlider extends Component{
    onInit( el, args ) {
        this.onNext     = this.onNext.bind(this);
        this.onPrev     = this.onPrev.bind(this);
        this.onSelect   = this.onSelect.bind(this);

        this.el             = el;
        this.slides         = this.el.querySelectorAll('.js-slide');

        if ( window.matchMedia("(min-width:1024px)").matches ) {
            this.nextBtn = this.el.querySelector('.next');
            this.prevBtn = this.el.querySelector('.prev');
            this.tabsContainer = this.el.parentNode.querySelector('.js-slider-tabs');
            this.tabs = this.tabsContainer.querySelectorAll('.js-slider-tab');
        }
    }

    onReady() {
        // adds '.js-slide'
        this.addSlideClass();

        // init slider
        this.initSlider();

        // hide controls if 1 slide
        if(this.slides.length < 2) {
            this.el.querySelector('.sliderBtns').style.display = 'none';
        } else {
            this.el.querySelector('.sliderBtns').style.display = 'block';
        }

        if ( window.matchMedia("(min-width:1024px)").matches ) {
            // events on nav buttons
            this.nextBtn.addEventListener(device.pointerdown, this.onNext);
            this.prevBtn.addEventListener(device.pointerdown, this.onPrev);

            if (this.tabsContainer && this.tabs) {
                for (let i = 0; i < this.tabs.length; i++) {
                    this.tabs[i].addEventListener(device.pointerdown, this.onSelect);
                }
            }
        }

        // disable horizontal scroll
        document.body.classList.add('js-has-flickity');
    }

    onNext() {
        this.slider.next();
        this.switchActiveTab();
        this.onSlideChange();
    }

    onPrev() {
        this.slider.previous();
        this.switchActiveTab();
        this.onSlideChange();
    }

    onSelect(e){
        if ( !e.target.classList.contains('js-slider-tab') ){
            return;
        }

        let tabs = Array.prototype.slice.call(this.tabs);
        let index = tabs.indexOf( e.target );

        this.slider.select( index );
        this.switchActiveTab();
    }

    onSlideChange() {

        if ( this.slider.selectedIndex == this.slider.slides.length -1 ) {
            this.el.classList.add('is-last');
        } else {
            this.el.classList.remove('is-last');
        }
    }

    switchActiveTab(){
        for (let i = 0; i < this.tabs.length; i++){
            this.tabs[i].classList.remove('active');
        }

        for (let i = 0; i < this.tabs.length; i++){
            if (this.slider.selectedIndex == this.tabs[i].dataset.id) {
                this.tabs[i].classList.add('active');
            }
        }
    }

    addSlideClass(){
        for (var i = 0; i < this.slides.length; i++){
            this.slides[i].classList.add('slide');
        }
    }

    initSlider(){
        var options = {
            cellSelector: '.slide',
            pageDots: false,
            cellAlign : 'left',
            prevNextButtons: false,
            wrapAround: true,
            imagesLoaded: true
        };

        if ( window.matchMedia('screen and (max-width: 1080px)').matches ) {
            options.draggable = true;
        } else {
            options.draggable = false;
        }

        // init slider
        this.slider = new Flickity(this.el, options);

    }

};
